/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { getAbsenceClasses } from '@absences/store/absences.selectors';
import { Pipe, PipeTransform } from '@angular/core';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { AbsenceClass } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'absenceClass',
    standalone: false
})
export class AbsenceClassPipe implements PipeTransform {
  constructor(private store: Store<State>) { }

  transform(absenceClassId: number): Observable<AbsenceClass> {
    return this.store.select(getAbsenceClasses).pipe(
      map(classes => classes.filter(absenceClass => absenceClass.id === absenceClassId)[0])
    );
  }
}
